module.exports = __webpack_public_path__ + "img/winnie-v2.1f2a0bf6.png";